var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 44.672,
    viewBox: "0 0 32 44.672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:none;}.a{stroke:#4a4a4a;stroke-width:3px;}.b{fill:#4a4a4a;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1035.712 -1464.648)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(1035.712 1464.648)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 16,
    cy: 15.5,
    rx: 16,
    ry: 15.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 16,
    cy: 15.5,
    rx: 14.5,
    ry: 14
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.2,0l3.221,5.1,5.982,1.4-3.991,4.56.476,5.973L9.2,14.755,3.515,17.042l.476-5.973L0,6.509,5.982,5.1Z",
    transform: "translate(1042.51 1471.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2236.175,601v15.567l7.6-5.408,7.621,5.408V601Z",
    transform: "translate(-1191.842 892.753)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.40f4947f4c6cfd767797268fce241f03.svg";
export { ForwardRef as ReactComponent };